import { render, staticRenderFns } from "./flowingWater.vue?vue&type=template&id=e23f574a&scoped=true&"
import script from "./flowingWater.vue?vue&type=script&lang=js&"
export * from "./flowingWater.vue?vue&type=script&lang=js&"
import style0 from "./flowingWater.vue?vue&type=style&index=0&id=e23f574a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23f574a",
  null
  
)

export default component.exports